import React, { useState } from "react";
import Input from "../../../../../widget/common/form/Input";
import PhoneNumber from "../../../../../widget/common/form/PhoneNumber";
import { SignupPersonalInformationContextImport } from "../../../../../provider/onboarding/signup/personal_information/SignupPersonalInformationContextProvider";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../../libraries/state_reducers/widget/ModalsReducer";
import { setupGeoDetail } from "../../../../../libraries/state_reducers/country_state_city_area/CountyStateCityAreaReducer";
import ModalKeys from "../../../../../const/ModalKeys";

export const SignupFirstNameField = () => {
  const { firstNameField, profileValidate, profileErrors, handleOnChange } =
    SignupPersonalInformationContextImport();

  return (
    <Input
      type={`text`}
      name="first_name"
      handleOnChange={handleOnChange}
      value={firstNameField}
      validate={true}
      label="first_name"
      error={profileValidate ? !profileErrors.firstNameField : false}
    />
  );
};

export const SignupLastNameField = () => {
  const { lastNameField, profileValidate, profileErrors, handleOnChange } =
    SignupPersonalInformationContextImport();
  return (
    <Input
      type={`text`}
      name="last_name"
      handleOnChange={handleOnChange}
      value={lastNameField}
      validate={true}
      label="last_name"
      error={profileValidate ? !profileErrors.lastNameField : false}
    />
  );
};

export const SignupPasswordField = () => {
  const { passwordField, profileValidate, profileErrors, handleOnChange } =
    SignupPersonalInformationContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };
  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="password"
      handleOnChange={handleOnChange}
      value={passwordField}
      validate={true}
      label="password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={profileValidate ? !profileErrors.passwordField : false}
      showPassHint={true}
    />
  );
};

export const SignupPasswordConfimField = () => {
  const {
    passwordConfirmField,
    profileValidate,
    profileErrors,
    handleOnChange,
  } = SignupPersonalInformationContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };
  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="password_confirm"
      handleOnChange={handleOnChange}
      value={passwordConfirmField}
      validate={true}
      label="confirm_password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={profileValidate ? !profileErrors.passwordConfirmField : false}
      showPassHint={true}
    />
  );
};

export const SignupEmailField = () => {
  const {
    emailField,
    profileValidate,
    profileErrors,
    handleOnChange,
    verificationType,
  } = SignupPersonalInformationContextImport();

  return (
    <Input
      type="email"
      name="email"
      handleOnChange={handleOnChange}
      value={emailField}
      validate={verificationType === "email"}
      label={verificationType === "email" ? "email" : "email_optional"}
      error={
        verificationType === "email"
          ? profileValidate
            ? !profileErrors.emailField
            : false
          : false
      }
    />
  );
};

export const SignupPhoneField = () => {
  const {
    phoneField,
    profileValidate,
    profileErrors,
    phoneCodeField,
    handleOnChange,
    applyCountryCode,
    verificationType,
  } = SignupPersonalInformationContextImport();

  return (
    <PhoneNumber
      name="phone_number_optional"
      handleOnChange={handleOnChange}
      value={phoneField}
      code={phoneCodeField}
      validate={verificationType === "phone"}
      label={
        verificationType === "phone" ? "phone_number" : "phone_number_optional"
      }
      error={
        verificationType === "phone"
          ? profileValidate
            ? !profileErrors.phoneField
            : false
          : false
      }
      callback={applyCountryCode}
    />
  );
};

export const SignupCityField = () => {
  const dispatch = useDispatch();
  const {
    countryId,
    countryName,
    stateId,
    stateName,
    cityId,
    cityName,
    profileValidate,
    profileErrors,
  } = SignupPersonalInformationContextImport();

  const handleClickCity = () => {
    dispatch(
      addModal({
        id: ModalKeys.choose_city_of_residence,
        title: "choose_city_of_residence",
      })
    );

    dispatch(
      setupGeoDetail({
        country: { country_id: countryId, country_name: countryName },
        state: { state_id: stateId, state_name: stateName },
        city: { city_id: cityId, city_name: cityName },
      })
    );
  };

  return (
    <div role="button" onClick={handleClickCity}>
      <Input
        type={`text`}
        name="city_of_residence"
        value={cityName}
        label="city_of_residence"
        readOnly={true}
        error={profileValidate ? !profileErrors.cityName : false}
      />
    </div>
  );
};
